import React, { useState} from 'react';
import InitData from './InitData';
import StoreLocations from './locations';
import { useSelector } from 'react-redux';
// import { useJsApiLoader } from '@react-google-maps/api';
import SkeletonLoader from './SkeletonLoader';
import ListLayout from './templates/ListLayout';
var App = () => {
  InitData();
  StoreLocations();
  const LocationsData = useSelector(state => state.StoreLocations);
  // const [ libraries ] = useState(['places']);
  // useJsApiLoader({ googleMapsApiKey: 'AIzaSyDYCSSv9O2XmFIWrsBRFDvcNLRephrpcmE', libraries: libraries });
  if ( undefined === LocationsData.data ) {
    return(<SkeletonLoader />);
  }
  return  <ListLayout />
}
export default App;